/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//home page featured collection list tittle height same     

/* Inside Continental US or Canada form in product detail page */
/*$('#r-form').submit(function(e) {
  var falg = 1;
  e.preventDefault();
  $('.loader-img').show();
  $('.btn.btn-theme').hide();
  $('.errorDiv').html('');
  
  var firstname = $('#firstname').val();
  var lastname = $('#lastname').val();
  var email = $('#email').val();
  var telephone = $('#telephone').val();
  
  var address = $('#address').val();
  var address2 = $('#address2').val();
  var city = $('#city').val();
  var state = $('#state').val();
  var zipcode = $('#zipcode').val();
  var country = $('#country').val();
  var productId = $('#productId').val();
  
  $(".error").remove();

  if (firstname == '') {
    falg = 0;
    $('#firstname').after('<span class="error">Please Enter Your First Name.</span>');
  }
  if (lastname == '') {
    falg = 0;
    $('#lastname').after('<span class="error">Please Enter Your Last Name.</span>');
  }
   if (email == '') {
    falg = 0;
    $('#email').after('<span class="error">Please Enter Your Email Address.</span>');
  }
  else{
    var regEx = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;;
    var validEmail = regEx.test(email);
    if (!validEmail) {
      falg = 0;
      $('#email').after('<span class="error">Please Enter Your valid Email Address.</span>');
    }
  }
  if (telephone == '') {
    falg = 0;
    $('#telephone').after('<span class="error">Please Enter Your Phone Number.</span>');
  }
  
  if (address == '') {
    falg = 0;
    $('#address').after('<span class="error">Please Enter Your Billing Address.</span>');
  }
  if (city == '') {
    falg = 0;
    $('#city').after('<span class="error">Please Enter Your Billing City.</span>');
  }
  if (state == '') {
    falg = 0;
    $('#state').after('<span class="error">Please Enter Your Enter Your Billing State.</span>');
  }
  if (zipcode == '') {
    falg = 0;
    $('#zipcode').after('<span class="error">Please Enter Your Billing Zip Code.</span>');
  }
  if (country == '') {
    falg = 0;
    $('#country').after('<span class="error">Please Enter Your Billing Country.</span>');
  }
  
  if(falg == 1){
    $.ajax({
      url: 'https://cp.suburbanseats.com/draft-order',
      type: 'post',
      dataType: 'html',
      data: $('form#r-form').serialize(),
      success: function(data) {
        console.log(data);
        var responseObj = jQuery.parseJSON(data);
        console.log(responseObj);
        $('.loader-img').hide();
        if(responseObj.success == 0){
          $('#successDiv').hide();
          $('#errorDiv').show();
          $('#errorDiv').html('');
          $('#errorDiv').append(responseObj.message);
        }
        else{
          $('#successDiv').show();
          $('#errorDiv').hide();
          $('#successDiv').html('');
          $('#successDiv').append(responseObj.message);
          
          setTimeout(function(){
            $("#successDiv").hide();
          }, 4000);
          $("form#r-form").trigger("reset");
        }
        $('.btn.btn-theme').show();
      }
    });
  }
  else{
    $('#errorDiv').show();
    $('.loader-img').hide();
    $('.btn.btn-theme').show();
    $('#errorDiv').append('Some error(s) occurred in form, please check.');
  }
});*/

/* Outside Continental US or Canada form in cart page */
/*$('#cart-r-form').submit(function (e) {

   var falg = 1;
  e.preventDefault();
  $('.loader-img').show();
  $('.btn.btn-theme').hide();
  $('.errorDiv').html('');
  
  var firstname = $('#firstname').val();
  var lastname = $('#lastname').val();
  var email = $('#email').val();
  var telephone = $('#telephone').val();
  
  var address = $('#address').val();
  var address2 = $('#address2').val();
  var city = $('#city').val();
  var state = $('#state').val();
  var zipcode = $('#zipcode').val();
  var country = $('#country').val();
  var productId = $('#productId').val();

  $(".error").remove();

  if (firstname == '') {
    falg = 0;
    $('#firstname').after('<span class="error">Please Enter Your First Name.</span>');
  }
  if (lastname == '') {
    falg = 0;
    $('#lastname').after('<span class="error">Please Enter Your Last Name.</span>');
  }
   if (email == '') {
    falg = 0;
    $('#email').after('<span class="error">Please Enter Your Email Address.</span>');
  }
  else{
    var regEx = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;;
    var validEmail = regEx.test(email);
    if (!validEmail) {
      falg = 0;
      $('#email').after('<span class="error">Please Enter Your valid Email Address.</span>');
    }
  }
  if (telephone == '') {
    falg = 0;
    $('#telephone').after('<span class="error">Please Enter Your Phone Number.</span>');
  }
  
  if (address == '') {
    falg = 0;
    $('#address').after('<span class="error">Please Enter Your Billing Address.</span>');
  }
  if (city == '') {
    falg = 0;
    $('#city').after('<span class="error">Please Enter Your Billing City.</span>');
  }
  if (state == '') {
    falg = 0;
    $('#state').after('<span class="error">Please Enter Your Enter Your Billing State.</span>');
  }
  if (zipcode == '') {
    falg = 0;
    $('#zipcode').after('<span class="error">Please Enter Your Billing Zip Code.</span>');
  }
  if (country == '') {
    falg = 0;
    $('#country').after('<span class="error">Please Enter Your Billing Country.</span>');
  }
  
  if(falg == 1){
    //Todo: Get Card Product info
    var data_array = [];
    $('.line-item--stack').each(function (index, element) {
      let product_id= $(this).data('product-id');
      let qty = $(this).find("#"+product_id+"_qty_box").val();
      data_array.push([product_id , qty]);
      
    });
    // console.log(data_array);
    
    
    let _firstname = $('#firstname').val();
    let _lastname = $('#lastname').val();
    let _email = $('#email').val();
    let _telephone = $('#telephone').val();
    
    let _address = $('#address').val();
    let _address2 = $('#address2').val();
    let _city = $('#city').val();
    let _state = $('#state').val();
    let _zipcode = $('#zipcode').val();
    let _country = $('#country').val();
   
    
    $.ajax({
      url: 'https://cp.suburbanseats.com/draft-cart-order',
      type: 'post',
      data:  {
                     product_infos:data_array ,
                     firstname : _firstname,
                     lastname : _lastname,
                     email : _email,
                     telephone: _telephone,
                     
                     address: _address,
                     address2:_address2,
                     city: _city,
                     state: _state,
                     zipcode: _zipcode,
                     country: _country
                     
                     },
      dataType:'html',
      success: function(data) {
        console.log(data);
        var responseObj = jQuery.parseJSON(data);
        console.log(responseObj);
        $('.loader-img').hide();
        if(responseObj.success == 0){
          $('#successDiv').hide();
          $('#errorDiv').show();
          $('#errorDiv').html('');
          $('#errorDiv').append(responseObj.message);
        }
        else{
          $('#successDiv').show();
          $('#errorDiv').hide();
          $('#successDiv').html('');
          $('#successDiv').append(responseObj.message);
          
          setTimeout(function(){
            $("#successDiv").hide();
          }, 4000);
          $("form#cart-r-form").trigger("reset");
        }
        $('.btn.btn-theme').show();
      }
    });
  }
  else{
    $('#errorDiv').show();
    $('.loader-img').hide();
    $('.btn.btn-theme').show();
    $('#errorDiv').append('Some error(s) occurred in form, please check.');
  }
});*/

$('#address-list-po').change(function (e) {
  var selectVal = this.value;
  var selectValArr = selectVal.split('$$');
  
  $('#firstname-po').val(selectValArr[0]);
  $('#lastname-po').val(selectValArr[1]);
  $('#address-po').val(selectValArr[2]);
  $('#address2-po').val(selectValArr[3]);
  $('#city-po').val(selectValArr[4]);
  $('#state-po').val(selectValArr[5]);
  $('#zipcode-po').val(selectValArr[6]);
  $('#country-po').val(selectValArr[7]);
});

$('.po-order').click(function (e) {
  var productPrice = eval($('#productPrice').val()) / 100;
  var productQty = $('#quantity-sele').val();
  var productTotal = eval(productQty) * eval(productPrice);
  $('#modal-purchase-order .item-final-qantity').html('<span>'+productQty+'</span> x$'+productPrice);
  $('#modal-purchase-order .item-final-price').html('$'+productTotal);
  $('#modal-purchase-order .checkout-list-price-bold').html('$'+productTotal);
});

/* id customer is login then single order */
$('#r-form-po-order').submit(function(e) {
  var falg = 1;
  e.preventDefault();
  $('#loader-img-po').show();
  $('.btn.btn-theme').hide();
  $('.errorDiv').html('');
  
  var firstname = $('#firstname-po').val();
  var lastname = $('#lastname-po').val();
  var email = $('#email-po').val();
  var telephone = $('#telephone-po').val();
  
  var address = $('#address-po').val();
  var address2 = $('#address2-po').val();
  var city = $('#city-po').val();
  var state = $('#state-po').val();
  var zipcode = $('#zipcode-po').val();
  var country = $('#country-po').val();
  var productId = $('#productId').val();
  var productQty = $('#quantity-sele').val();
  var poNumber = $('#po-number-po').val();
  var unitNUmber = $('#unit-number-po').val();
  var orderNote = $('textarea#orderNote-po').val();

  $(".error").remove();

  if (firstname == '') {
    falg = 0;
    $('#firstname-po').after('<span class="error">Please Enter Your First Name.</span>');
  }
  if (lastname == '') {
    falg = 0;
    $('#lastname-po').after('<span class="error">Please Enter Your Last Name.</span>');
  }
   if (email == '') {
    falg = 0;
    $('#email-po').after('<span class="error">Please Enter Your Email Address.</span>');
  }
  else{
    var regEx = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;;
    var validEmail = regEx.test(email);
    if (!validEmail) {
      falg = 0;
      $('#email-po').after('<span class="error">Please Enter Your valid Email Address.</span>');
    }
  }
  if (telephone == '') {
    falg = 0;
    $('#telephone-po').after('<span class="error">Please Enter Your Phone Number.</span>');
  }
  
  if (address == '') {
    falg = 0;
    $('#address-po').after('<span class="error">Please Enter Your Billing Address.</span>');
  }
  if (city == '') {
    falg = 0;
    $('#city-po').after('<span class="error">Please Enter Your Billing City.</span>');
  }
  if (state == '') {
    falg = 0;
    $('#state-po').after('<span class="error">Please Enter Your Billing State.</span>');
  }
  if (zipcode == '') {
    falg = 0;
    $('#zipcode-po').after('<span class="error">Please Enter Your Billing Zip Code.</span>');
  }
  if (country == '') {
    falg = 0;
    $('#country-po').after('<span class="error">Please Enter Your Billing Country.</span>');
  }
  if (poNumber == '') {
    falg = 0;
    $('#po-number-po').after('<span class="error">Please Enter PO Number.</span>');
  }
  
  if(falg == 1){
    
    $.ajax({
      url: 'https://cp.suburbanseats.com/create-order',
      type: 'post',
      dataType: 'html',
      data:  {
        firstname : firstname,
        lastname : lastname,
        email : email,
        telephone: telephone,
        address: address,
        address2:address2,
        city: city,
        state: state,
        zipcode: zipcode,
        country: country,
        productId:productId,
        productQty:productQty,
        poNumber:poNumber,
        unitNUmber:unitNUmber,
        orderNote:orderNote
      },
      success: function(data) {
        console.log(data);
        var responseObj = jQuery.parseJSON(data);
        console.log(responseObj);
        
        $('.loader-img').hide();
        if(responseObj.success == 0){
          
          $('#successDiv-po').hide();
          $('#errorDiv-po').show();
          $('#errorDiv-po').html('');
          $('#errorDiv-po').append(responseObj.message);
        }
        else{
          $('#successDiv-po').show();
          $('#errorDiv-po').hide();
          $('#successDiv-po').html('');
          $('#successDiv-po').append(responseObj.message);
          window.location.href=responseObj.message;
          setTimeout(function(){
            $("#successDiv").hide();
          }, 4000);
          $("form#r-form").trigger("reset");
        }
        $('.btn.btn-theme').show();
      }
    });
  }
  else{
    $('#errorDiv-po').show();
    $('#loader-img-po').hide();
    $('.btn.btn-theme').show();
    $('#errorDiv-po').append('Some error(s) occurred in form, please check.');
  }
});

/* id customer is login then multiple order cart page */
$('#r-form-po-order-cart').submit(function(e) {
  var falg = 1;
  e.preventDefault();
  $('#loader-img-po').show();
  $('.button.button--primary').hide();
  $('.errorDiv').html('');
  
  var firstname = $('#firstname-po').val();
  var lastname = $('#lastname-po').val();
  var email = $('#email-po').val();
  var telephone = $('#telephone-po').val();
  
  var address = $('#address-po').val();
  var address2 = $('#address2-po').val();
  var city = $('#city-po').val();
  var state = $('#state-po').val();
  var zipcode = $('#zipcode-po').val();
  var country = $('#country-po').val();
  var productId = $('#productId').val();
  var poNumber = $('#po-number-po').val();
  var unitNUmber = $('#unit-number-po').val();
  var orderNote = $('textarea#orderNote-po').val();

  var default_fname = $('#default_fname').val();
  var default_lname = $('#default_lname').val();
  var default_address1 = $('#default_address1').val();
  var default_address2 = $('#default_address2').val();
  var default_city = $('#default_city').val();
  var default_province = $('#default_province').val();
  var default_zip = $('#default_zip').val();
  var default_country = $('#default_country').val();
  var default_address_id = $('#default_address_id').val();
  var customer_id = $('#customer_id').val();
  
  $(".error").remove();

  if (firstname == '') {
    falg = 0;
    $('#firstname-po').after('<span class="error">Please Enter Your First Name.</span>');
  }
  if (lastname == '') {
    falg = 0;
    $('#lastname-po').after('<span class="error">Please Enter Your Last Name.</span>');
  }
   if (email == '') {
    falg = 0;
    $('#email-po').after('<span class="error">Please Enter Your Email Address.</span>');
  }
  else{
    var regEx = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;;
    var validEmail = regEx.test(email);
    if (!validEmail) {
      falg = 0;
      $('#email-po').after('<span class="error">Please Enter Your valid Email Address.</span>');
    }
  }
  if (telephone == '') {
    falg = 0;
    $('#telephone-po').after('<span class="error">Please Enter Your Phone Number.</span>');
  }
  
  if (address == '') {
    falg = 0;
    $('#address-po').after('<span class="error">Please Enter Your Billing Address.</span>');
  }
  if (city == '') {
    falg = 0;
    $('#city-po').after('<span class="error">Please Enter Your Billing City.</span>');
  }
  if (state == '') {
    falg = 0;
    $('#state-po').after('<span class="error">Please Enter Your Billing State.</span>');
  }
  if (zipcode == '') {
    falg = 0;
    $('#zipcode-po').after('<span class="error">Please Enter Your Billing Zip Code.</span>');
  }
  if (country == '') {
    falg = 0;
    $('#country-po').after('<span class="error">Please Enter Your Billing Country.</span>');
  }
  if (poNumber == '') {
    falg = 0;
    $('#po-number-po').after('<span class="error">Please Enter PO Number.</span>');
  }
  
  if(falg == 1){
    
    var data_array = [];
    $('.line-item--stack').each(function (index, element) {
      let product_id= $(this).data('product-id');
      let qty = $(this).find("#"+product_id+"_qty_box").val();

      data_array.push([product_id , qty]);
    });
    
    $.ajax({
      url: 'https://cp.suburbanseats.com/create-cart-order',
      type: 'post',
      dataType: 'html',
      type: 'post',
      data:  {
        product_infos:data_array ,
        firstname : firstname,
        lastname : lastname,
        email : email,
        telephone: telephone,
        address: address,
        address2:address2,
        city: city,
        state: state,
        zipcode: zipcode,
        country: country,
        poNumber:poNumber,
        unitNUmber:unitNUmber,
        orderNote:orderNote,
        default_fname:default_fname,
        default_lname:default_lname,
        default_address1:default_address1,
        default_address2:default_address2,
        default_city:default_city,
        default_province:default_province,
        default_zip:default_zip,
        default_country:default_country,
        customer_id:customer_id,
        default_address_id:default_address_id
      },
      success: function(data) {
        console.log(data);
        var responseObj = jQuery.parseJSON(data);
        console.log(responseObj);
        $('.loader-img').hide();
        if(responseObj.success == 0){
          $('#successDiv-po').hide();
          $('#errorDiv-po').show();
          $('#errorDiv-po').html('');
          $('#errorDiv-po').append(responseObj.message);
        }
        else{
          $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            data: '',
            dataType: 'json',
            success: function() { 
                Shopify.clear();
            },
            error: function(XMLHttpRequest, textStatus) {
              /* error code */
            }
          });
          window.location.href=responseObj.message;
        }
        $('.btn.btn-theme').show();
      }
    });
  }
  else{
    $('#errorDiv-po').show();
    $('#loader-img-po').hide();
    $('.button.button--primary').show();
    $('#errorDiv-po').append('Some error(s) occurred in form, please check.');
  }
});

$('.po-order-cart').click(function (e) {
  
  var data_array = [];
  var cartItemStr = '';
  var cartTotalPrice = '';
  $('.line-item--stack').each(function (index, element) {
    let product_id= $(this).data('product-id');
    let product_title= $(this).data('product-title');
    let product_link= $(this).data('product-link');
    let product_image= $(this).data('product-image');
    let product_price= eval($(this).data('product-price')) / 100;
    let product_item_price= eval($(this).data('item-price')) / 100;
    let qty = $(this).find("#"+product_id+"_qty_box").val();
    
    data_array.push([product_id , qty]);
    
    cartItemStr += '<div class="purchase-item">';
    cartItemStr += '<img class="item-image" src="'+product_image+'" alt="'+product_title+'">';
    cartItemStr += '<div class="item-title"> <a class="item-title-link" href="'+product_link+'">'+product_title+'</a> </div>';
    cartItemStr += '<div class="item-final-qantity" id="span-item-po-qty"> <span>'+qty+'</span> x$'+product_price+' </div>';
    cartItemStr += '<div class="item-final-price"> $'+product_item_price+' </div>';
    cartItemStr += '</div>';
    
	
  });
  $('.purchase-item-cart').html('');
  $('.purchase-item-cart').html(cartItemStr);
  
  var cartTotalPrice = $('#cartTotalPrice').html();
  $('#modal-purchase-order .checkout-list-price-bold').html(cartTotalPrice);
  
});

// search open close 
function myFunction(){
  jQuery('body').addClass('js-search-active');
}
function mycloseFunction(){
  jQuery('body').removeClass('js-search-active');
}

//place order popup model 
function modalPurchase(){
  jQuery('#modal-purchase-order').show();
  jQuery('.modal-backdrop').remove();
  jQuery('#shopify-section-footer').after('<div class="modal-backdrop fade show"></div>');
}
function closePurmodal(){
	jQuery('#modal-purchase-order').hide();
    jQuery('.modal-backdrop').remove();
}

/* collection listing page get a quote button */
jQuery('.get-a-quote').click(function(){
  var ptitle = jQuery(this).parent().parent().find('.product-item__title').text();
  var sku = jQuery(this).parent().parent().find('.product-sku').text();
  jQuery('#producttitle').val(ptitle);
  jQuery('#productsku').val(sku);
  jQuery('.successDiv').html("");
  jQuery('.errorDiv').html("");
  //jQuery('#getquotemodel').modal('show');
})

/* product detail page request a quote button */
jQuery('.product-form__add-button').click(function(){
  var ptitle = jQuery(this).parent().parent().parent().find('.product-meta .product-meta__title').text();
  var sku = jQuery(this).parent().parent().parent().find('.product-meta .product-meta__reference .product-meta__sku').text();
  jQuery('#producttitle').val(ptitle);
  jQuery('#productsku').val(sku);
  jQuery('.successDiv').html("");
  jQuery('.errorDiv').html("");
})

/* collection listing page Notify button */
/*jQuery('.get-a-notify').click(function(){
  jQuery('#notifycustomerid').val('');
  jQuery('#notifycustomertags').val('');
  var ptitle = jQuery(this).parent().parent().find('.product-item__title').text();
  var customerid = jQuery(this).parent().parent().find('input[name="customer_id"]').val();
  var customertags = '';
  jQuery(this).parent().parent().find('input[name="customer_tags[]"]').each(function(){
    customertags += jQuery(this).val()+'$#$';
  })
  var pid = jQuery(this).parent().attr('id');
  var matches = pid.match(/(\d+)/);
  jQuery('#notifyproducttitle').val(ptitle);
  jQuery('#notifyptitle').html(ptitle);
  jQuery('#notifycustomerid').val(customerid);
  jQuery('#notifycustomertags').val(customertags);
  jQuery('#notifyproductid').val(matches[0]);
  jQuery('.successDiv').html("");
  jQuery('.errorDiv').html("");

})*/

/* Product Detail page Notify me button */
jQuery('.notify-single').click(function(){
  jQuery('#notifycustomerid').val('');
  jQuery('#notifycustomertags').val('');
  var ptitle = jQuery(this).parent().parent().parent().find('.product-meta .product-meta__title').text();
  var psku = jQuery(this).parent().parent().parent().find('.product-meta .product-meta__sku-number').text();
  var customerid = jQuery(this).parent().parent().parent().find('input[name="customer_id"]').val();
  var customertags = '';
  jQuery(this).parent().parent().parent().find('input[name="customer_tags[]"]').each(function(){
    customertags += jQuery(this).val()+'$#$';
  })
  var pid = jQuery(this).parent().parent().attr('id');
  var matches = pid.match(/(\d+)/);
  jQuery('#notifyproducttitle').val(ptitle);
  jQuery('#notifyproductsku').val(psku);
  jQuery('#notifyptitle').html(ptitle);
  jQuery('#notifycustomerid').val(customerid);
  jQuery('#notifycustomertags').val(customertags);
  jQuery('#notifyproductid').val(matches[0]);
  jQuery('.successDiv').html("");
  jQuery('.errorDiv').html("");
})

/* Cart page request a quote button */
jQuery('.modal-request-a-quote-cart').click(function(){
  var ptitle = '';
  var skus = '';
  jQuery('.line-item-table > .line-item > tr').each(function () {
    ptitle += jQuery(this).attr('data-product-title') + '$#$';
    skus += jQuery(this).attr('data-item-sku') + '$#$';
  });

  jQuery('#producttitle').val(ptitle);
  jQuery('#productsku').val(skus);
  jQuery('.successDiv').html("");
  jQuery('.errorDiv').html("");
}) 

/* collection listing page get a quote form submit event */
$('#get-quote-form').on('submit', function (e) {
  var flag = [];
  var quotefirstname = $('#quotefirstname').val();
  var quotelastname = $('#quotelastname').val();
  var quoteemail = $('#quoteemail').val();
  var quotetelephone = $('#quotetelephone').val();
  var quoteaddress = $('#quoteaddress').val();
  var quotecity = $('#quotecity').val();
  var quotestate = $('#quotestate').val();
  var quotezipcode = $('#quotezipcode').val();
  var quotecountry = $('#quotecountry').val();
  var vyear = $('#vyear').val();
  var vmake = $('#vmake').val();
  var vmodel = $('#vmodel').val();
  var comments = $('#comments').val();

  if(quotefirstname == ''){
    $('#quote_first_name_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_first_name_err').text('');
    flag.push(0);
  }

  if(quotelastname == ''){
    $('#quote_last_name_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_last_name_err	').text('');
    flag.push(0);
  }


  if(quoteemail == ''){
    $('#quote_email_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    if(!pattern.test(quoteemail)) {
      $('#quote_email_err').text('Enter Valid email address!!');
      flag.push(1);
    }else{
      $('#quote_email_err').text('');
      flag.push(0);
    }

  }


  if(quotetelephone == ''){
    $('#quote_phone_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_phone_err').text('');
    flag.push(0);
  }


  if(quoteaddress == ''){
    $('#quote_address_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_address_err').text('');
    flag.push(0);
  }


  if(quotecity == ''){
    $('#quote_city_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_city_err').text('');
    flag.push(0);
  }


  if(quotestate == ''){
    $('#quote_state_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_state_err').text('');
    flag.push(0);
  }


  if(quotezipcode == ''){
    $('#quote_zip_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_zip_err').text('');
    flag.push(0);
  }

  if(quotecountry == ''){
    $('#quote_country_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_country_err').text('');
    flag.push(0);
  }

  if(vyear == ''){
    $('#quote_vyear_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vyear_err').text('');
    flag.push(0);
  }

  if(vmake == ''){
    $('#quote_vmake_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vmake_err').text('');
    flag.push(0);
  }

  if(vmodel == ''){
    $('#quote_vmodel_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vmodel_err').text('');
    flag.push(0);
  }

  if(comments == ''){
    $('#quote_comments_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_comments_err').text('');
    flag.push(0);
  }

  e.preventDefault();
  if(flag.includes(1) == false){
    $('.loader-img').css('display','block');
    $.ajax({
      type: 'post',
      url: 'https://cp.suburbanseats.com/get-a-quote',
      data: $('#get-quote-form').serialize(),
      dataType:'json',
      success: function (data) {
        if(data == 1){
          $('.successDiv').html("Quote Send Successfully");
          $('#getquotemodel').attr('aria-hidden','true');
          $('.loader-img').css('display','none');
          $('#getquotemodel').css('tabindex','');
          $('html').removeClass('is-locked');
          $('#get-quote-form')[0].reset();
        }
      }
    });
  }


});

/* product detail page request a quote submit event */
$('#get-quote-form-single').on('submit', function (e) {
  var flag = [];
  var quotefirstname = $('#quotefirstname').val();
  var quotelastname = $('#quotelastname').val();
  var quoteemail = $('#quoteemail').val();
  var quotetelephone = $('#quotetelephone').val();
  var quoteaddress = $('#quoteaddress').val();
  var quotecity = $('#quotecity').val();
  var quotestate = $('#quotestate').val();
  var quotezipcode = $('#quotezipcode').val();
  var quotecountry = $('#quotecountry').val();
  var vyear = $('#vyear').val();
  var vmake = $('#vmake').val();
  var vmodel = $('#vmodel').val();
  var comments = $('#comments').val();

  if(quotefirstname == ''){
    $('#quote_first_name_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_first_name_err').text('');
    flag.push(0);
  }

  if(quotelastname == ''){
    $('#quote_last_name_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_last_name_err	').text('');
    flag.push(0);
  }


  if(quoteemail == ''){
    $('#quote_email_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    if(!pattern.test(quoteemail)) {
      $('#quote_email_err').text('Enter Valid email address!!');
      flag.push(1);
    }else{
      $('#quote_email_err').text('');
      flag.push(0);
    }

  }


  if(quotetelephone == ''){
    $('#quote_phone_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_phone_err').text('');
    flag.push(0);
  }


  if(quoteaddress == ''){
    $('#quote_address_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_address_err').text('');
    flag.push(0);
  }


  if(quotecity == ''){
    $('#quote_city_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_city_err').text('');
    flag.push(0);
  }


  if(quotestate == ''){
    $('#quote_state_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_state_err').text('');
    flag.push(0);
  }


  if(quotezipcode == ''){
    $('#quote_zip_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_zip_err').text('');
    flag.push(0);
  }

  if(quotecountry == ''){
    $('#quote_country_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_country_err').text('');
    flag.push(0);
  }

  if(vyear == ''){
    $('#quote_vyear_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vyear_err').text('');
    flag.push(0);
  }

  if(vmake == ''){
    $('#quote_vmake_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vmake_err').text('');
    flag.push(0);
  }

  if(vmodel == ''){
    $('#quote_vmodel_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vmodel_err').text('');
    flag.push(0);
  }

  if(comments == ''){
    $('#quote_comments_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_comments_err').text('');
    flag.push(0);
  }

  e.preventDefault();
  if(flag.includes(1) == false){
    $('.loader-img').css('display','block');
    $.ajax({
      type: 'post',
      url: 'https://cp.suburbanseats.com/get-a-quote',
      data: $('#get-quote-form-single').serialize(),
      dataType:'json',
      success: function (data) {
        if(data == 1){
          $('.successDiv').html("Quote Send Successfully");
          $('#getquotemodelsingle').attr('aria-hidden','true');
          $('.loader-img').css('display','none');
          $('#getquotemodelsingle').css('tabindex','');
          $('html').removeClass('is-locked');
          $('#get-quote-form-single')[0].reset();
        }
      }
    });
  }


});

/* Cart page request a quote submit event */
$('#get-quote-form-cart').on('submit', function (e) {
  var flag = [];
  var quotefirstname = $('#quotefirstname').val();
  var quotelastname = $('#quotelastname').val();
  var quoteemail = $('#quoteemail').val();
  var quotetelephone = $('#quotetelephone').val();
  var quoteaddress = $('#quoteaddress').val();
  var quotecity = $('#quotecity').val();
  var quotestate = $('#quotestate').val();
  var quotezipcode = $('#quotezipcode').val();
  var quotecountry = $('#quotecountry').val();
  var vyear = $('#vyear').val();
  var vmake = $('#vmake').val();
  var vmodel = $('#vmodel').val();
  var comments = $('#comments').val();

  if(quotefirstname == ''){
    $('#quote_first_name_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_first_name_err').text('');
    flag.push(0);
  }

  if(quotelastname == ''){
    $('#quote_last_name_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_last_name_err	').text('');
    flag.push(0);
  }


  if(quoteemail == ''){
    $('#quote_email_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    if(!pattern.test(quoteemail)) {
      $('#quote_email_err').text('Enter Valid email address!!');
      flag.push(1);
    }else{
      $('#quote_email_err').text('');
      flag.push(0);
    }

  }


  if(quotetelephone == ''){
    $('#quote_phone_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_phone_err').text('');
    flag.push(0);
  }


  if(quoteaddress == ''){
    $('#quote_address_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_address_err').text('');
    flag.push(0);
  }


  if(quotecity == ''){
    $('#quote_city_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_city_err').text('');
    flag.push(0);
  }


  if(quotestate == ''){
    $('#quote_state_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_state_err').text('');
    flag.push(0);
  }


  if(quotezipcode == ''){
    $('#quote_zip_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_zip_err').text('');
    flag.push(0);
  }

  if(quotecountry == ''){
    $('#quote_country_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_country_err').text('');
    flag.push(0);
  }

  if(vyear == ''){
    $('#quote_vyear_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vyear_err').text('');
    flag.push(0);
  }

  if(vmake == ''){
    $('#quote_vmake_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vmake_err').text('');
    flag.push(0);
  }

  if(vmodel == ''){
    $('#quote_vmodel_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_vmodel_err').text('');
    flag.push(0);
  }

  if(comments == ''){
    $('#quote_comments_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#quote_comments_err').text('');
    flag.push(0);
  }

  e.preventDefault();
  if(flag.includes(1) == false){
    $('.loader-img').css('display','block');
    $.ajax({
      type: 'post',
      url: 'https://cp.suburbanseats.com/get-a-quote',
      data: $('#get-quote-form-cart').serialize(),
      dataType:'json',
      success: function (data) {
        if(data == 1){
          $('.successDiv').html("Quote Send Successfully");
          $('#modal-request-a-quote-cart').attr('aria-hidden','true');
          $('.loader-img').css('display','none');
          $('#modal-request-a-quote-cart').css('tabindex','');
          $('html').removeClass('is-locked');
          $('#get-quote-form-cart')[0].reset();
        }
      }
    });
  }


});

/* collection listing page notify me submit event */
/*$('#get-notification-form').on('submit', function (e) {
  var flag = [];
  var notifyemail = $('#notifyemail').val();
  if(notifyemail == ''){
    $('#notify_email_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    if(!pattern.test(notifyemail)) {
      $('#notify_email_err').text('Enter Valid email address!!');
      flag.push(1);
    }else{
      $('#notify_email_err').text('');
      flag.push(0);
    }

  }      


  e.preventDefault();
  if(flag.includes(1) == false){
    $('.loader-img').css('display','block');
    $.ajax({
      type: 'post',
      url: 'https://cp.suburbanseats.com/set-a-notification',
      data: $('#get-notification-form').serialize(),
      dataType:'json',
      success: function (data) {
        if(data == 1){
          $('.successDiv').html("Thank you for your interest! We'll notify you as soon as the item is available");
          $('.loader-img').css('display','none');
          $('#get-notification-form')[0].reset();
        }else{
          $('.loader-img').css('display','none');
          $('.errorDiv').html("You are already subscribed to our mailing list.");
        }
        setTimeout(function() {
          $('.successDiv').html('');
          $('.errorDiv').html('');
        }, 3000);
      }
    });
  }


});*/

/* Product Detail page Notify me submit event */
$('#get-notification-single-form').on('submit', function (e) {
  var flag = [];
  var notifyemail = $('#notifyemail').val();
  var notifyname = $('#notifyname').val();
  var notifyphone = $('#notifyphone').val();
  
  if(notifyname == ''){
    $('#notify_name_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#notify_name_err').text('');
    flag.push(0);
  }
  
  if(notifyemail == ''){
    $('#notify_email_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    if(!pattern.test(notifyemail)) {
      $('#notify_email_err').text('Enter Valid email address!!');
      flag.push(1);
    }else{
      $('#notify_email_err').text('');
      flag.push(0);
    }

  }      
  
  if(notifyphone == ''){
    $('#notify_phone_err').text('This Filed is required!!');
    flag.push(1);
  }else{
    $('#notify_phone_err').text('');
    flag.push(0);
  }


  e.preventDefault();
  if(flag.includes(1) == false){
    $('.loader-img').css('display','block');
    $.ajax({
      type: 'post',
      url: 'https://cp.suburbanseats.com/set-a-notification',
      data: $('#get-notification-single-form').serialize(),
      dataType:'json',
      success: function (data) {
        if(data == 1){
          $('.successDiv').html("Thank you for your interest! We'll notify you as soon as the item is available");
          $('.loader-img').css('display','none');
          $('#get-notification-single-form')[0].reset();
        }else{
          $('.loader-img').css('display','none');
          $('.errorDiv').html("You are already subscribed to our mailing list.");
        }
        setTimeout(function() {
          $('.successDiv').html('');
          $('.errorDiv').html('');
        }, 3000);
      }
    });
  }


});

function resetData(){
  $('#get-quote-form')[0].reset();
}

function resetDataSingle(){
  $('#get-quote-form-single')[0].reset();
}

function resetNotificationSingle(){
  $('#get-notification-single-form')[0].reset();
}

function resetNotification(){
  $('#get-notification-form')[0].reset();
}

function resetDataCart(){
  $('#get-quote-form-cart')[0].reset();
}

$(document).ready(function() {
  $('body').on('click', '[name="checkout"]', function() {
    var frmSubmit = '';
    var userType = $(this).attr('data-type');
    if(userType == 'normal'){
      if ($('#address_type').val() != '') {
        
        frmSubmit = 1;
      }
      else {
        alert("Please select address type");
        return false;
      }
  
      var lift_gate = inside_delivery = limited_access = none_of_these = '';
      if ($('#lift_gate').is(":checked")){
        lift_gate = 1;
      }
      if ($('#limited_access').is(":checked")){
        limited_access = 1;
      }
      if ($('#inside_delivery').is(":checked")){
        inside_delivery = 1;
      }
      if ($('#none_of_these').is(":checked")){
        none_of_these = 1;
      }
  
      if(lift_gate == 1 || limited_access == 1 || inside_delivery == 1 || none_of_these == 1){
        frmSubmit = 1;
      }
      else{
        alert("Please select delivery type");
        return false;
      }
  
      if(frmSubmit == 1){
        $(this).submit();
      }
    }
    else{
      $(this).submit();
    }
    
  });
});